<template>
<div>
  <b-card>
    <div class="text-right mb-3">
      <router-link class="btn btn-primary" :to="{name:'families.create'}"><i class="fa fa-plus"></i> Criar</router-link>
    </div>
    <local-grid name="familiesGridv2" :preload="preload" height="calc(100vh - 250px)" :editable="true" v-bind:url="url" v-bind:columns="columns" :pageable='false' :filterable='true' :sortable='true' v-bind:schemaModelFields="schemaModelFields"></local-grid>
  </b-card>
</div>
</template>

<script>
import LocalGrid from '@/components/LocalGrid.vue'
import States from '@/components/Lists.js'
import router from '@/router'

export default {
  name: 'FamiliesGrid',
  components: {
    LocalGrid
  },
  data() {
    return {
      schemaModelFields: {
        'created_at': {
          type: 'date'
        },
        'id': {
          type: 'number',
          editable: false
        },
        'membership_type_id': {
          type: 'number',
          editable: true
        },
        'code': {
          type: 'number',
          editable: false
        }
      },
      url: 'families',
      preload: [{
        api: 'regions/lst',
        field: 'region_id'
      }, {
        api: 'countries/lst',
        field: 'country_id'
      }, {
        api: 'membershiptypes/lst',
        field: 'membership_type_id'
      }],
      columns: [{
        template: this.getBtnTemplate,
        title: '',
        width: '120px'
      },
      {
        field: 'code',
        title: 'ID Família',
        width: '90px',
        editable: false
      },
      {
        field: 'surname',
        title: 'Apelido',
        width: '180px'
      },
      {
        field: 'state',
        title: 'Estado',
        width: '100px',
        values: States.states
      },
      {
        field: 'address',
        title: 'Morada',
        width: '180px'
      },
      {
        field: 'zip_code',
        title: 'Código Postal',
        width: '180px'
      },
      {
        field: 'locality',
        title: 'Localidade',
        width: '180px'
      },
      {
        field: 'country_id',
        title: 'País',
        width: '180px'
      },
      {
        field: 'region_id',
        title: 'Código de Zona',
        width: '180px'
      },
      {
        field: 'phone',
        title: 'Contacto Telefónico',
        width: '180px'
      },
      {
        field: 'email',
        title: 'Email',
        width: '180px'
      },
      {
        field: 'notes',
        title: 'Observações',
        width: '180px'
      },
      {
        field: 'membership_type_id',
        title: 'Tipo de Sócio',
        width: '180px'
      },
      {
        field: 'latestFeeYear',
        title: 'Última Quota',
        width: '180px',
        editable: false
      },
      {
        field: 'id',
        title: 'Id',
        width: '80px',
        editable: false
      },
      {
        field: 'created_at',
        title: 'Criado em',
        format: '{0:dd/MM/yyyy HH:mm}',
        type: 'date',
        width: '180px',
        filterable: {
          // ui: "datetimepicker"
          ui: function(element) {
            element.kendoDateTimePicker({
              format: 'dd/MM/yyyy HH:mm'
            })
          }
        }
      }]
    }
  },
  methods: {
    getBtnTemplate: function(item) {
      if (this.$auth.check('families.edit')) {
        var route = router.resolve({
          name: 'families.edit',
          params: {
            id: item.id
          }
        })
        return '<a href="' + route.href + '" class="btn btn-primary" ><i class="fa fa-pencil"></i> editar</a>'
      } else if (this.$auth.check('families.view')) {
        var route = router.resolve({
          name: 'families.view',
          params: {
            id: item.id
          }
        })
        return '<a href="' + route.href + '" class="btn btn-primary" ><i class="fa fa-pencil"></i> editar</a>'
      }
      return ''
    }
  }
}
</script>
